import {$swoole} from './axios.setup'

// getReportInspectionOverseas
// - 2026.03.26
export const getReportInspectionOverseas = async ({params}) => {
  const url = '/v1/vehicleInspection/exportCar/appraise'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}
